window.Blimp = window.Blimp || {};

class ZoomPhotoView extends Backbone.View {
  get className() {
    return 'photo';
  }

  get events() {
    return {
      'click img': 'toggle_zoom'
    };
  }

  // Toggles between fit-to-screen and 200% of the fitted size, so zooming
  // works even when the screen is larger than the photo's native resolution.
  // When zoomed in, the .photo container scrolls natively to pan. Returning
  // false stops the click from bubbling to ZoomView's close handler.
  toggle_zoom(e) {
    if (this.$el.hasClass('zoomed')) {
      this.$el.removeClass('zoomed');
      e.currentTarget.style.width = '';
    } else {
      const img = e.currentTarget;
      const rect = img.getBoundingClientRect();
      const fx = (e.clientX - rect.left) / rect.width;
      const fy = (e.clientY - rect.top) / rect.height;
      this.$el.addClass('zoomed');
      img.style.width = `${rect.width * 2}px`;
      // Scroll so the clicked spot ends up in the center of the screen
      this.el.scrollLeft = fx * img.clientWidth - this.el.clientWidth / 2;
      this.el.scrollTop = fy * img.clientHeight - this.el.clientHeight / 2;
    }
    return false;
  }

  render(
    // Reason behind muted or not:
    // https://help.uberflip.com/hc/en-us/articles/360048856591-Why-are-my-autoplay-videos-muted-#:~:text=Answer,videos%20to%20autoplay%20with%20sound.
    muted = true
  ) {
    const top_controls = $('<div class="top controls"/>');
    top_controls.append(`<h2>${this.model.index()}/${this.model.report.photos.length} – ${this.model.report.get('references')[0]}</h2>`);
    top_controls.append('<a href="#" class="close"><i class="fa fa-times-circle fa-lg"></i></a>');
    this.$el.append(top_controls);

    const bottom_controls = $('<div class="bottom controls"/>');
    if (this.model.has('taken_at')) { // old reports are missing taken_at attributes in json cache
      bottom_controls.append(`<div class="meta">${this.model.taken_at().format('dddd, YYYY-MM-DD, HH:mm (UTC Z)')}</div>`);
    }
    if (Blimp.can_delete_photos) {
      bottom_controls.append('<a href="#" class="delete">Delete</a>');
    }
    bottom_controls.append(`<a href="${this.model.download_url()}" class="download">Download</a>`);
    this.$el.append(bottom_controls);

    if (this.model.is_video()) {
      this.$el.append(`
        <video class="video-player" width="${this.model.get('width')}" height="${this.model.get('height')}" autoplay ${muted ? 'muted' : ''} controls>
          <source src="${this.model.zoom_url()}" type="video/mp4">
        Your browser does not support the video tag.
        </video>
      `);
    } else {
      if (this.model.preloaded) {
        this.$el.append(`<img src="${this.model.zoom_url()}">`);
      } else {
        this.$el.append(`<img src="${this.model.thumb_url()}">`);
        const img = new Image();
        img.onload = () => {
          const current = this.$el.find('img');
          img.style.width = current[0].style.width; // keep zoom level across the swap
          current.replaceWith(img);
          this.model.preloaded = true;
        };
        img.src = this.model.zoom_url();
      }
    }

    return this;
  }
}

Blimp.ZoomPhotoView = ZoomPhotoView;